module.exports = __webpack_public_path__ + "static/media/drbot-logo.98f94c5e.png";